export const CO_API = {
  Success: "success",
  Failed: "failed",
}

export const NUMBER_OF_BUSSINESS_TRUST_CO = '65,000+'
export const MAX_EMAIL_ADDRESSES_ALLOWED_QUICK_VALIDATION = 100
export const PERSIST_COOKIE_GTM_CAMPAIGN_URL = "__gtm_campaign_url" // this cookie is set by GTM tag using PERSIST COOKIE MODULE
export const CALENDLY_URLS = {
  BOOK_A_DEMO: "https://calendly.com/clearout/30min?embed_domain=clearout.io&embed_type=PopupText",
  CONNECT_TO_LIVE_SUPPORT: "https://calendly.com/clearout/connect-to-live-support?embed_domain=clearout.io&embed_type=PopupText"
}